// 迁移内容
export default {
  'migrate.layout.text1':
    'Please ensure that you complete the migration of the new platform before February 26, 2025 (UTC+8). The old platform will be taken down in the future. The new platform will provide better functional services and inherit your remaining balance on the platform. If you have any questions, please contact customer service or send support@lightcdn.com Email for support. Go to the new platform →',
  'migrate.layout.text2':
    'You have confirmed that you have started using the new platform, and the old platform will be taken down on February 26, 2025（UTC+8）. If neecessary, please download the historical data as soon as possible and migrate the CDN resources to the new platform. Go to the new platform →',
  'migrate.MoveContent.title1': 'Super simple Migration, just copy and activate!',
  'migrate.MoveContent.title2':
    'Thank you for your continued support! LightCDN will provide you with better service!',
  'migrate.MoveContent.title1.step1': 'Copy your exclusive code:',
  'migrate.MoveContent.title1.step2.0': 'Go to',
  'migrate.MoveContent.title1.step2.1': 'New client',
  'migrate.MoveContent.title1.step2.2': 'Home',
  'migrate.MoveContent.title1.step2.3': ', paste your exclusive code.',
  'migrate.MoveContent.title1.step3':
    'Wait for five minutes, balance migration, and resources will be automatically created for you.',
  'migrate.MoveContent.title1.step4': 'Activate resources to use!',
  'migrate.MoveContent.title2.text':
    'The migration process takes 5-10 minutes, please do not close the window!',
  'migrate.MoveContent.title2.input': 'Please fill in your unique code',
  'migrate.MoveContent.title2.start': 'Start migration',
  'migrate.MoveContent.title2.tip':
    '*This feature is only available to users who still have normal business resources on the old platform',
  'migrate.MoveContent.title2.step1': 'Activate 30-day 500G core tier traffic...',
  'migrate.MoveContent.title2.step2': 'Preparing to migrate data for you',
  'migrate.MoveContent.title2.step3.0': 'Balance Migration...',
  'migrate.MoveContent.title2.step3.1': 'Resource Creation...',
  'migrate.MoveContent.title2.step4': 'Migration completed, go to activate resources',
  'migrate.MoveContent.title2.step4.total': 'Resource creation status: total ',
  'migrate.MoveContent.title2.step4.tip0':
    'Please note: The scope of resource is for resources that are still in normal use on the old client.',
  'migrate.MoveContent.title2.step4.tip1': 'Reason for creation failure: ',
  'migrate.MoveContent.title2.step4.tip2': '1. It may have been created on a new platform',
  'migrate.MoveContent.title2.step4.tip3':
    '2. These failed resources may not have been successfully created due to network fluctuations, and they need to be manually created after confirmation',
  'migrate.MoveContent.title2.step4.tip4':
    'If you have too many failed resources, please send an email to support@lightcdn.com',
  'migrate.MoveContent.title2.step4.btn': 'Go to CDN Resource',
  'migrate.MoveContent.title2.text.btn':
    'Click here to view the resources that failed to be created',
  'migrate.APIKey':
    "To ensure that your migration process does not encounter any issues, we will temporarily suspend the API's external access during the migration period.",
  'migrate.monthPlanAndRecharge':
    'To ensure that your migration process does not encounter any issues, we will temporarily suspend the purchase of monthly plans and recharge entrances during the migration period.',

  'migrate.register.title.0':
    'The current LightCDN old client platform supports  to migrate platform content to the new platform, ',
  'migrate.register.title.1': 'registration is temporarily not open.',
  'migrate.register.title.2': 'Welcome new users to use the new client platform( ',
  'migrate.register.title.3': ' ).',
  'migrate.register.left.title': 'Migration Guide for Old Users',
  'migrate.register.left.1.0': 'Go to ',
  'migrate.register.left.1.1': 'Old paltform → Home',
  'migrate.register.left.1.2': ', copy your exclusive code',
  'migrate.register.left.2.0':
    'Paste and copy the exclusive code in the migration moudle of the current page.',
  'migrate.register.left.2.1': '',
  'migrate.register.left.2.2': '',
  'migrate.register.left.3':
    'A single resource can be completed in just a few seconds. Automatically migrate your balance and create resources for you.',
  'migrate.register.left.4': 'Activate resources and complete DNS resolution to use!',
  'migrate.register.right.title.1': 'Time notification',
  'migrate.register.right.1.0': 'Migration Begins',
  'migrate.register.right.1.1':
    'The new platform at https://console.lightcdn.com will go live. You can begin migrating your resources at your convenience. We will assist you in easily recreating your existing resources and transferring your balance (the 500GB of core network traffic will be reset, whether fully used or not; we encourage trial users to migrate as well). Migrating a single resource will only take a few seconds and requires only DNS reconfiguration, minimizing any potential impact on your business.',
  'migrate.register.right.1.2':
    'The old platform at https://client.lightcdn.com will stop allowing new purchases and resource creation. However, your existing resources will remain operational and unaffected until you complete the migration to the new platform.',
  'migrate.register.right.title.2': 'Migration Ends',
  'migrate.register.right.2.0':
    'The old platform will be decommissioned, meaning any resources on the old platform will stop accelerating. If you have not migrated by this date, your services will be interrupted.',
};
